import heroSaoSebastiao from "../assets/SSebas.png";
import heroMariaAdelina from "../assets/NewAdelina.png";
import heroSaoMiguel from "../assets/saomiguelhero.png";
import heroJoseMaria from "../assets/JoseMariaHero.png";

const villaHeroImages = {
  "villa-sao-sebastiao": heroSaoSebastiao,
  "villa-maria-adelina": heroMariaAdelina,
  "villa-terra-rosa": heroSaoMiguel,
  "villa-azul-mar": heroJoseMaria,
};

export function getVillaHeroImage(slug) {
  return villaHeroImages[slug];
}

export default villaHeroImages;
